import { render, staticRenderFns } from "./GenericCardProductList.vue?vue&type=template&id=972c98ba&scoped=true&"
import script from "./GenericCardProductList.vue?vue&type=script&lang=js&"
export * from "./GenericCardProductList.vue?vue&type=script&lang=js&"
import style0 from "./GenericCardProductList.vue?vue&type=style&index=0&id=972c98ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c98ba",
  null
  
)

export default component.exports